<template lang="pug">
    .property.full-height-error.not-valid(v-if="!enabledExtensions.includes('shop')")
        Error(:message="null" :code="403")
    .property.full-height-error.not-allowed(v-else-if="pathNotValid")
        Error(:message="$t('URL Not Valid')")
    .property.full-height-error(v-else-if="error")
        template(v-if="error.code")
            Error(:message="$t(error.message || 'Something went wrong!')" :code="error.code")
        template(v-else)
            Error(:message="$t('Something went wrong!')" :code="501")
    .property(v-else)
        tabs(:items="tabs" :active-tab="$route.fullPath" @click="activateTab")
            template(slot="tabbar-buttons")
                // el-tooltip(class="item" effect="dark" :content="$t('Delete')" placement="bottom")
                //     el-button.delete-button(circle type="danger" icon="el-icon-fa-trash-alt far")
                // el-tooltip(class="item" effect="dark" :content="$t('Dismiss')" placement="bottom")
                //     el-button(circle icon="el-icon-fa-times fas")
                // el-tooltip(class="item" effect="dark" :content="$t('Save and close')" placement="bottom")
                //     el-button(circle type="primary" icon="el-icon-fa-check fas")
                // el-tooltip(class="item" effect="dark" :content="$t('Save')" placement="bottom")
                //     el-button(circle type="success" icon="el-icon-fa-save fas")
                //- el-button.delete-button(
                //-     circle v-if="! loading && isDeletable"
                //-     type="danger"
                //-     icon="el-icon-fa-trash-alt far"
                //-     :loading="deleting"
                //-     :disabled="isDisabledSubmit && ! deleting"
                //-     @click="deleteCurrentProperty"
                //- )
                el-button(
                    circle icon="el-icon-fa-times fas"
                    :disabled="isDisabledSubmit"
                    @click="leave"
                )
                el-button(
                    circle v-if="! loading"
                    type="primary"
                    icon="el-icon-fa-check fas"
                    :loading="saving === 'leave'"
                    :disabled="saving !== false && saving !== 'leave'"
                    @click="submit($event, listRoute)"
                )
                el-button(
                    circle v-if="! loading"
                    type="success"
                    icon="el-icon-fa-save fas"
                    :loading="saving === 'stay'"
                    :disabled="saving !== false && saving !== 'stay'"
                    @click="submit"
                )

        el-form(label-position="top" :model="form" :rules="rules" ref="form")
            all-input-fields
            el-card(shadow="always" v-loading="loading")
                .i18n-select-container(v-if="i18n && allowedToTranlsate && languageOptions.length > 1 && defaultLanguage")
                    el-form-item.flex-row(:label="$t('Language')")
                        el-select(
                            :placeholder="$t('Default Language ({code})', { code: defaultLanguage.code.toUpperCase() })"
                            v-model="language"
                            value-key="code"
                        )
                            template(v-slot:prefix)
                                span.i18n-flag.circle.fi.fis(
                                    v-if="activeTranslation"
                                    :class="`fi-${activeTranslation.language.flag || getLanguageFlag(activeTranslation.language.code)}`"
                                )
                                span.i18n-flag.circle.fi.fis(
                                    v-else
                                    :class="`fi-${defaultLanguage.flag || getLanguageFlag(defaultLanguage.code)}`"
                                )
                            el-option(
                                v-for="item in languageOptions"
                                :key="item.code"
                                :label="getLanguageName(item.code)"
                                :value="item"
                                :disabled="!activeTranslation && item.code === defaultLanguage.code"
                            )
                                .flex-row
                                    .col.grow
                                        span.i18n-flag.circle.fi.fis(:class="`fi-${item.flag || getLanguageFlag(item.code)}`")
                                        span {{ getLanguageName(item.code) }}
                                    .col.gray-text
                                        small.uppercase(v-if="item.code === defaultLanguage.code") {{ $t('Default') }}
                                        small.uppercase(v-else-if="!findTranslation(item.code)") {{ $t('New') }}
                        el-button.delete-button(
                            v-if="activeTranslation"
                            circle
                            size="mini"
                            type="danger"
                            icon="el-icon-fa-trash-alt far"
                            :loading="saving === 'delete-translation'"
                            @click="deleteTranslation(activeTranslation)"
                        )
                router-view.property-form(:key="$route.path" :class="{'loading-panel': loading}")
            .form-buttons
                el-button(
                    round v-if="! loading"
                    icon="el-icon-fa-times fas"
                    :disabled="isDisabledSubmit"
                    @click="leave"
                ) {{ $t('Dismiss') }}
                el-button(
                    round v-if="! loading"
                    type="primary"
                    icon="el-icon-fa-check fas"
                    :loading="saving === 'leave'"
                    :disabled="saving !== false && saving !== 'leave'"
                    @click="submit($event, listRoute)"
                ) {{ $t('Save and close') }}
                el-button(
                    round v-if="! loading"
                    type="success"
                    icon="el-icon-fa-save fas"
                    :loading="saving === 'stay'"
                    :disabled="saving !== false && saving !== 'stay'"
                    @click="submit"
                ) {{ $t('Save') }}

        el-dialog.i18n-dialog(
            :title="$t('Translate Property')"
            :visible.sync="translateDialog.visibility"
            :append-to-body="true"
            :width="translateDialog.supportedAutoTranslate ? '780px' : '640px'"
            @closed="resetTranslateDialog"
        )
            .body(v-loading="translateDialog.loading")
                el-form(
                    v-if="translateDialog.form"
                    label-position="left"
                    :model="translateDialog.form"
                    :rules="translateDialogRules"
                    ref="translate-dialog-form"
                )
                    p.mb-6(
                        v-if="translateDialog.form.language"
                        v-html="$t('How should the property be translated into <b>{language}</b>?', { language: getLanguageName(translateDialog.form.language.code) })"
                    )

                    el-form-item.hide-label.mb-6(:label="$t('Translation Type')" prop="type")
                        el-button-group
                            //- warning
                            el-button(
                                v-if="translateDialog.supportedAutoTranslate"
                                size="mini"
                                type="primary"
                                :plain="translateDialog.form.type !== 'auto-translate'"
                                icon="el-icon-fa-flask fas"
                                @click="translateDialog.form.type = 'auto-translate'"
                            ) {{ $t('Translate automatically') }}

                            //- primary
                            //- plain

                            el-button(
                                size="mini"
                                type="primary"
                                :plain="translateDialog.form.type !== 'create-empty'"
                                icon="el-icon-fa-square far"
                                @click="translateDialog.form.type = 'create-empty'"
                            ) {{ $t('Create empty translation') }}

                            //- primary

                            el-button(
                                size="mini"
                                type="primary"
                                :plain="translateDialog.form.type !== 'copy-origin'"
                                icon="el-icon-fa-clone fas"
                                @click="translateDialog.form.type = 'copy-origin'"
                            ) {{ $t('Duplicate default language') }}

                    transition(name="slide-decent-vertical" mode="out-in")
                        .alert.warning.flex-row.mt-0(
                            key="auto-translate-warning"
                            v-if="translateDialog.supportedAutoTranslate && translateDialog.form.type === 'auto-translate'"
                        )
                            .icon
                                //- i.el-icon-fa-flask-vial.fas
                                //- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path d="M224 32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H224 192 64 32 16C7.2 0 0 7.2 0 16s7.2 16 16 16H32V352c0 53 43 96 96 96c11.2 0 22-1.9 32-5.5c0-14.2 3-28.3 8.8-41.2C157.7 410.5 143.5 416 128 416c-35.3 0-64-28.7-64-64V192H192V352c0 4-.4 7.8-1 11.6l33-53.7V32zM64 32H192V160H64V32zM304 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h16V219.5L201.8 411.6c-6.4 10.4-9.8 22.3-9.8 34.5c0 36.4 29.5 65.9 65.9 65.9H574.1c36.4 0 65.9-29.5 65.9-65.9c0-12.2-3.4-24.1-9.8-34.5L512 219.5V32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zM480 32V224c0 3 .8 5.9 2.4 8.4L536.3 320H295.7l53.9-87.6c1.6-2.5 2.4-5.4 2.4-8.4V32H480zM229 428.4L276 352H556l47 76.4c3.3 5.3 5 11.5 5 17.8c0 18.7-15.2 33.9-33.9 33.9H257.9c-18.7 0-33.9-15.2-33.9-33.9c0-6.3 1.7-12.4 5-17.8z"/></svg>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path class="fa-secondary" opacity=".4" d="M175 389.4l49-79.6V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H160 96 32C14.3 0 0 14.3 0 32S14.3 64 32 64V352c0 53 43 96 96 96c11.2 0 22-1.9 32-5.5c0-18.7 5.2-37.1 15-53.1zM96 64h64v96H96V64z"/><path class="fa-primary" d="M480 0H352 320c-17.7 0-32 14.3-32 32s14.3 32 32 32V214.9L202.3 406.2c-6.7 10.9-10.3 23.5-10.3 36.4c0 38.3 31.1 69.4 69.4 69.4H570.6c38.3 0 69.4-31.1 69.4-69.4c0-12.8-3.6-25.4-10.3-36.4L512 214.9V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H480zM384 224V64h64V224c0 5.9 1.6 11.7 4.7 16.8L501.5 320h-171l48.8-79.2c3.1-5 4.7-10.8 4.7-16.8z"/></svg>
                            .grow
                                b {{ $t('Warning!') }}
                                p {{ $t('The auto translation is an experimental feature. Results may not meet your expectation. Check the result carefully!') }}
                        //- .translate-properties(v-else-if="translateDialog.form.properties.length && ['create-empty', 'copy-origin'].includes(translateDialog.form.type)")
                        //-     el-switch.mb-6(
                        //-         key="translate-properties"
                        //-         :active-text="$t('Translate Properties')"
                        //-         v-model="translateDialog.translateProperties"
                        //-     )
                        //-     transition(name="slide-decent-vertical" mode="out-in")
                        //-         .properties-panel(v-if="translateDialog.translateProperties")
                        //-             .table-head
                        //-                 b.table-label.text-center {{ getLanguageName(defaultLanguage.code) }}
                        //-                 b.table-content.text-center {{ getLanguageName(translateDialog.form.language.code) }}
                        //-             .property(v-for="(property, index) in translateDialog.form.properties" :key="property.id")
                        //-                 el-form-item(:label="property.translationOrigin.name" :prop="`properties.${index}.name`")
                        //-                     el-input(v-model="property.name")

            template(slot="footer" class="dialog-footer")
                .modal-footer
                    .left
                        el-button(
                            size="mini"
                            icon="el-icon-fa-times fas"
                            :disabled="translateDialog.saving !== false"
                            @click="translateDialog.visibility = false"
                        ) {{ $t('Dismiss') }}
                    .right
                        el-button(
                            size="mini"
                            type="primary"
                            :loading="translateDialog.saving"
                            @click="createTranslation"
                        ) {{ $t('Create Translation') }}
</template>

<i18n>
{
    "en": {
        "Default Language ({code})": "Default Language ({code})",
        "How should the property be translated into <b>{language}</b>?": "How should the property be translated into <b>{language}</b>?"
    },
    "de": {
        "Property dependencies could not be fetched.": "Attributabhängigkeiten konnten nicht abgerufen werden.",
        "Property could not be fetched.": "Attribut konnte nicht gefunden werden.",
        "Property could not be deleted.": "Attribut konnte nicht gelöscht werden.",
        "Property deleted successfully!": "Attribut erfolgreich gelöscht!",
        "Property could not be saved.": "Attribut konnte nicht gespeichert werden.",
        "Property saved successfully!": "Attribut erfolgreich gespeichert!",
        "Property Not Found": "Attribut nicht gefunden",
        "Property": "Attribut",

        "Language": "Sprache",
        "Translation": "Übersetzung",
        "Translation could not be created.": "Übersetzung konnte nicht erstellt werden.",
        "Translation deleted successfully.": "Übersetzung erfolgreich gelöscht.",
        "Translation could not be deleted.": "Übersetzung konnte nicht gelöscht werden.",
        "Translate Property": "Attribut übersetzen",
        "Translate automatically": "Automatisch übersetzen",
        "Create empty translation": "Leere Übersetzung erstellen",
        "Duplicate default language": "Standard-Sprache kopieren",
        "How should the property be translated into <b>{language}</b>?": "Wie soll das Attribut in die Sprache <b>{language}</b> übersetzt werden?",
        "Warning!": "Achtung!",
        "The auto translation is an experimental feature. Results may not meet your expectation. Check the result carefully!": "Die automatische Übersetzung ist ein experimentelles Feature. Die Ergebnisse entsprechen möglicherweise nicht Ihren Erwartungen. Überprüfen Sie das Ergebnis sorgfältig!",
        "Default": "Standard",
        "Default Language ({code})": "Standardsprache ({code})",
        "New": "Neu",

        "Create Translation": "Übersetzung erstellen",
        "Translate Properties": "Attribute übersetzen",
        "Translation Type": "Art der Übersetzung"
    }
}
</i18n>

<script>
import _ from 'lodash';
import { mapMutations, mapActions, mapGetters } from 'vuex';

import PropertyApi from '@/extensions/shop/store/api/property';

import { language, languageFlag, languageNativeName } from '@/filters'

import store from '@/store';
import router from '@/router';

import Tabs from '@/components/Tabs';
import Error from '@/components/Error';

// validate all fields, regardless if the corresponding component is mounted or not
import AllInputFields from './AllInputFields';

export default {
    name: 'Property',
    data() {
        return {
            listRoute: { name: 'property-list' },
            error: false,
            pathNotValid: false,
            loading: false,
            saving: false,
            deleting: false,

            translateDialog: {
                visibility: false,
                loading: false,
                saving: false,
                supportedAutoTranslate: false,
                translateProperties: true,
                form: {
                    property: undefined,
                    type: undefined, // create-empty, copy-origin, auto-translate
                    language: undefined,
                    // properties: [],
                },
            },
        };
    },
    components: {
        Tabs,
        Error,
        AllInputFields,
    },
    watch: {
        activeCms(cms) {
            const reload = _.get(cms, 'reloadComponents', true);
            if (reload) {
                this.setInitializedFlag(false);
                this.initialize();
            }
        }
    },
    computed: {
        id() {
            return _.get(this.form, 'id', false);
        },
        isDeletable() {
            return !!this.id;
        },
        isDisabledSubmit() {
            return this.saving !== false || this.deleting !== false;
        },
        i18nFeatureEnabled() {
            let features = _.get(this.activeCms, 'config.template.features') || [];
            return !!features.find(el => el === 'i18n');
        },
        i18n() {
            if (this.i18nFeatureEnabled) {
                return _.get(this.activeCms, 'i18n')
            }
        },
        allowedToTranlsate() {
            let allowed = true;
            if (!this.isSuperUser && !this.isOwner) {
                allowed = this.rights.find(right => {
                    return right.key === 'translations'
                        && right.permission.create
                        && right.permission.update
                        && right.permission.delete
                })
            }
            return allowed;
        },
        translateDialogRules() {
            let rules = {}
            if (!this.translateDialog.visibility) return rules

            rules.type = 'required'

            // if (this.translateDialog.translateProperties && this.translateDialog.form.properties.length &&
            //     ['create-empty', 'copy-origin'].includes(this.translateDialog.form.type)) {
            //     rules.properties = []
            //     this.translateDialog.form.properties.forEach(() => rules.properties.push({ name: 'required' }))
            // }

            return rules
        },
        activeTranslation() {
            if (this.form.translationOrigin) return this.form
        },
        languageOptions() {
            return _.get(this.activeCms, 'languages') || []
        },
        defaultLanguage() {
            return this.languageOptions.find(language => language.default)
        },
        language: {
            get() {
                return this.translateDialog.form.language || _.get(this.activeTranslation, 'language') || this.defaultLanguage
            },
            async set(value) {
                this.loading = true

                // check if translation is new
                // show dialog
                // - empty translation
                // - copy from default language
                // - translate automatically (if language is supported)
                // otherwise load translation

                const translation = this.findTranslation(value.code)

                if (value.code === this.defaultLanguage.code) {
                    // default language
                    // translation origin

                    if (this.form.translationOrigin) {
                        const property = await PropertyApi.fetchProperty(this.form.translationOrigin.id)
                            .catch(() => {
                                this.loading = false
                                this.$notify.error({
                                    title: this.$t('An error occurred!'),
                                    message: this.$t('Property could not be fetched.'),
                                    iconClass: 'fas el-icon-fa-xmark',
                                    position: 'bottom-left',
                                    customClass: 'dark',
                                    duration: 8000
                                });
                            })

                        this.insertProperty(property)
                    } else {
                        this.$notify.error({
                            title: this.$t('An error occurred!'),
                            message: this.$t('Property could not be fetched.'),
                            iconClass: 'fas el-icon-fa-xmark',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                    }

                } else if (!translation) {
                    // missing translation
                    // create a new one

                    this.translateDialog.form.property = { id: this.id }
                    this.translateDialog.form.language = value

                    // let pivots = this.form.propertyPivots
                    // if (this.activeTranslation) pivots = this.form.translationOrigin.propertyPivots
                    //
                    // this.translateDialog.form.properties = pivots.filter(el => {
                    //     return ! el.property.translations.find(el => el.language.code === value.code)
                    // }).map(el => ({
                    //     id: el.property.id,
                    //     name: '',
                    //     translationOrigin: {
                    //         name: el.property.name
                    //     }
                    // }))

                    this.translateDialog.visibility = true
                    this.translateDialog.loading = true

                    setTimeout(() => {
                        this.$refs['translate-dialog-form'].resetFields()
                        this.$refs['translate-dialog-form'].clearValidate()
                    }, 0)

                    const languages = this.libretranslate

                    if (languages && languages.length) {
                        const language = languages.find(el => el.code === this.defaultLanguage.code)
                        if (language && language.targets.includes(value.code)) {
                            this.translateDialog.supportedAutoTranslate = true
                        }
                    }

                    this.translateDialog.loading = false
                } else if (this.id) {
                    // load existing translation

                    const property = await PropertyApi.fetchTranslation(translation.id)
                        .catch(() => {
                            this.loading = false
                            this.$notify.error({
                                title: this.$t('An error occurred!'),
                                message: this.$t('Property could not be fetched.'),
                                iconClass: 'fas el-icon-fa-xmark',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });
                        })

                    this.insertProperty(property)
                }

                this.loading = false
            },
        },
        tabs() {
            const id = this.$route.params.id;
            const name = _.get(this.form, 'name') || this.$t('Property');

            let tabs = [
                {
                    name,
                    path: `/catalog/property/${id}/main`,
                    icon: {
                        name: 'cube',
                        group: 'fas'
                    }
                },
                // {
                //     name: this.$t('Prices'),
                //     path: `/catalog/property/${id}/prices`,
                //     icon: {
                //         name: 'euro-sign',
                //         group: 'fas'
                //     }
                // },
                // {
                //     name: this.$t('Stock & Individualization'),
                //     path: `/catalog/property/${id}/articles`,
                //     icon: {
                //         name: 'cubes',
                //         group: 'fas'
                //     }
                // }
            ];

            if (this.activeTranslation) {
                tabs = [
                    {
                        name,
                        path: `/catalog/property/${id}/main`,
                        icon: {
                            name: 'tag',
                            group: 'fas'
                        }
                    },
                    // {
                    //     name: this.$t('Sub-Articles'),
                    //     path: `/catalog/property/${id}/articles`,
                    //     icon: {
                    //         name: 'tags',
                    //         group: 'fas'
                    //     }
                    // }
                ]
            }

            return tabs
        },
        activeShop() {
            return this.activeCms.shop;
        },
        ...mapGetters({
            // activeTab: 'activeTabKey',
            // tabs: 'currentTabs',
            // validation
            form: 'ext_shop_property/form',
            initialized: 'ext_shop_property/form_initialized',
            validateOnEnter: 'ext_shop_property/form_validateOnEnter',
            rules: 'ext_shop_property/rules',

            libretranslate: 'libretranslate',
            locale: 'locale',

            rights: 'auth/rights',
            isSuperuser: 'auth/isSuperUser',
            isOwner: 'auth/isOwner',

            // cms
            activeCms: 'activeCms',
            enabledExtensions: 'enabledExtensions'
        })
    },
    methods: {
        async createTranslation() {
            this.$refs['translate-dialog-form'].validate(async (valid, errors) => {
                if (valid) {
                    this.translateDialog.saving = true

                    const translation = await this.translate(this.translateDialog.form)
                        .catch(() => {
                            this.translateDialog.saving = false
                            this.$notify.error({
                                title: this.$t('An error occurred!'),
                                message: this.$t('Translation could not be created.'),
                                iconClass: 'fas el-icon-fa-xmark',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });
                        })

                    // add translation to property
                    if (translation) {
                        this.addTranslation(translation)

                        const property = await PropertyApi.fetchTranslation(translation.id)
                            .catch(() => {
                                this.translateDialog.saving = false
                                this.$notify.error({
                                    title: this.$t('An error occurred!'),
                                    message: this.$t('Property could not be fetched.'),
                                    iconClass: 'fas el-icon-fa-xmark',
                                    position: 'bottom-left',
                                    customClass: 'dark',
                                    duration: 8000
                                });
                            })

                        this.insertProperty(property)
                    }

                    this.translateDialog.saving = false
                    this.translateDialog.visibility = false
                } else {
                    this.$notify.warning({
                        title: this.$t('Form is not valid!'),
                        message: this.$t('Correct your input and submit again.'),
                        iconClass: 'fas el-icon-fa-exclamation-circle',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                }
            })
        },
        async deleteTranslation(translation) {
            const payload = {
                id: this.form.translationOrigin.id,
                translations: this.form.translationOrigin.translations.map(el => {
                    if (el.id === translation.id) el.deleted = true
                    return el
                })
            }

            this.saving = 'delete-translation'
            PropertyApi.update(payload)
                .then(property => {
                    this.language = this.defaultLanguage
                    this.removeTranslation(translation)

                    this.$notify.success({
                        title: this.$t('Translation deleted successfully.'),
                        iconClass: 'fas el-icon-fa-check',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                })
                .catch(error => {
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Translation could not be deleted.'),
                        iconClass: 'fas el-icon-fa-xmark',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                    console.error(error)
                })
                .finally(() => this.saving = false)
        },
        resetTranslateDialog() {
            this.translateDialog = {
                visibility: false,
                loading: false,
                saving: false,
                supportedAutoTranslate: false,
                translateProperties: true,
                form: {
                    property: undefined,
                    type: undefined, // create-empty, copy-origin, auto-translate
                    language: undefined,
                    // properties: [],
                },
            }
        },
        getLanguageName(code) {
            return language(code, this.locale ? this.locale.value : 'de')
        },
        getLanguageFlag(code) {
            return languageFlag(code)
        },
        getLanguageNativeName(code) {
            return languageNativeName(code)
        },
        findTranslation(code) {
            let translations = this.form.translations || []
            if (this.activeTranslation) translations = this.form.translationOrigin.translations || []
            return translations.find(el => _.get(el, 'language.code') === code)
        },
        initialize() {
            if (!this.enabledExtensions.includes('shop')) {
                this.setInitializedFlag(true);
                return;
            }

            if (this.initialized !== true) {
                this.setInitializedFlag(true);

                let actions = [
                    this.fetchPropTypeOptions(this.activeShop.id),
                    this.fetchCustomerGroupOptions(this.activeShop.id),
                    this.fetchTaxOptions(this.activeShop.id),
                ];

                const fetchDependencies = () => {
                    // if (this.id) {
                    //     // set property filter for article list
                    //     const filter = {
                    //         key: 'property',
                    //         match: this.id
                    //     };
                    //     this.updateArticlesLoading(true);
                    //     this.defineArticleFilterValue({ key: 'property', value: filter });
                    //     this.defineArticlePaginationSizes([5, 10, 50]);
                    //     this.defineArticleItemsPerPage(10);
                    //     this.defineArticlesCurrentPage(1);
                    //     actions.push(
                    //         this.fetchArticlesPaginated({ scope: 'ex', type: 'shop_property_article' }).finally(() => {
                    //             this.updateArticlesLoading(false);
                    //         })
                    //     );
                    // }

                    return Promise.all(actions);
                };

                this.error = false;
                this.loading = true;

                const handleDependencyError = err => {
                    const { graphQLErrors } = err

                    let code = 501;
                    let message = 'An error occurred!';

                    if (graphQLErrors) {
                        code = _.get(graphQLErrors, '0.code') || code;
                        message = _.get(graphQLErrors, '0.message') || message;
                    }

                    let notify = true;
                    switch (code) {
                        case 401:
                            notify = false;
                            this.error = { code, message: 'You are not authorized' };
                            break;
                        case 403:
                            notify = false;
                            this.error = { code, message: 'You are not allowed to be here' };
                            break;
                        // case 404:
                        //     break;
                        default:
                            this.error = true;
                            break;
                    }

                    if (notify) {
                        this.$notify.error({
                            title: this.$t(message),
                            message: this.$t('Dependencies could not be fetched.'),
                            iconClass: 'fas el-icon-fa-xmark',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                    }

                    this.loading = false;

                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err);
                }

                if (this.$route.params.id === 'new') {
                    store.dispatch('ext_shop_property/reset');

                    // fetchDependencies().then(() => store.commit('ext_shop_property/updateRules', rules))
                    fetchDependencies()
                        .then(() => {
                            setTimeout(this.$refs.form.clearValidate, 0)
                        })
                        .catch(handleDependencyError)
                        .finally(() => {
                            this.loading = false;
                        });
                } else if (!isNaN(this.$route.params.id)) {
                    this.fetchProperty(this.$route.params.id)
                        .then(() => {
                            // store.commit('ext_shop_property/resetUI')

                            // fetch options for dropdowns
                            fetchDependencies()
                                .then(() => {
                                    store.commit('ext_shop_property/resetRules');
                                    // store.commit('ext_shop_property/resetUI')
                                    this.loading = false;
                                })
                                .catch(handleDependencyError);
                        })
                        .catch(err => {
                            const { graphQLErrors } = err

                            let code = 501;
                            let message = 'An error occurred!';

                            if (graphQLErrors) {
                                code = _.get(graphQLErrors, '0.code') || code;
                                message = _.get(graphQLErrors, '0.message') || message;
                            } else {
                                this.error = true;
                            }

                            switch (code) {
                                case 401:
                                    this.error = { code, message: 'You are not authorized' };
                                    break;
                                case 403:
                                    this.error = { code, message: 'You are not allowed to be here' };
                                    break;
                                case 404:
                                    this.error = { code, message: 'Property Not Found' };
                                    break;
                                default:
                                    this.$notify.error({
                                        title: this.$t('An error occurred!'),
                                        message: this.$t('Property could not be fetched.'),
                                        iconClass: 'fas el-icon-fa-xmark',
                                        position: 'bottom-left',
                                        customClass: 'dark',
                                        duration: 8000
                                    });
                                    break;
                            }

                            this.loading = false;

                            /* eslint no-console: ["error", { allow: ["error"] }] */
                            console.error(err);
                        });
                } else {
                    this.loading = true;
                    this.pathNotValid = true;
                }
            } else {
                if (this.validateOnEnter === true) {
                    setTimeout(() => {
                        this.$refs.form.validate(() => {
                            // do nothing
                            // callback function is required :(
                        });
                    }, 100);
                }
            }
        },
        deleteCurrentProperty() {
            this.deleting = true;
            this.delete(this.id)
                .then(() => {
                    // this.deleting = false

                    router.push(this.listRoute);

                    this.$notify.success({
                        title: this.$t('Property deleted successfully!'),
                        iconClass: 'fas el-icon-fa-check',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                })
                .catch(err => {
                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err);

                    this.deleting = false;

                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Property could not be deleted.'),
                        iconClass: 'fas el-icon-fa-xmark',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                });
        },
        submit(event, redirect = false) {
            this.$refs.form.validate((valid, errors) => {
                if (valid) {
                    if (redirect) this.saving = 'leave';
                    else this.saving = 'stay';

                    this.save(this.form)
                        .then(() => {
                            this.saving = false;

                            this.$notify.success({
                                title: this.$t('Property saved successfully!'),
                                iconClass: 'fas el-icon-fa-check',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });

                            if (redirect) {
                                router.push(redirect);
                            } else {
                                if (this.$route.params.id === 'new') {
                                    const route = router.currentRoute
                                    route.params.id = this.form.id
                                    router.replace(route)
                                }
                            }
                        })
                        .catch(err => {
                            /* eslint no-console: ["error", { allow: ["error"] }] */
                            console.error(err);

                            this.saving = false;

                            this.$notify.error({
                                title: this.$t('An error occurred!'),
                                message: this.$t('Property could not be saved.'),
                                iconClass: 'fas el-icon-fa-xmark',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });
                        });
                } else {
                    this.setValidateOnEnterFlag(true);

                    // check the invalid fields
                    // and go to the corresponding tab
                    // or open the corresponding closed area
                    // TODO: scroll to invalid field

                    let invalidTabs = [];
                    _.each(errors, (error, path) => {
                        if (_.indexOf(['nr', 'status', 'name', 'categories', 'media'], path) >= 0) {
                            invalidTabs.push(`/catalog/property/${this.$route.params.id}/main`);
                        }

                        // if (_.startsWith(path, 'mainPrice.')) {
                        //     invalidTabs.push(`/catalog/property/${this.$route.params.id}/prices`);
                        // }

                        if (_.startsWith(path, 'prices.')) {
                            invalidTabs.push(`/catalog/property/${this.$route.params.id}/prices`);
                            // store.commit('ext_shop_property/updateSpecialPricesVisibility', ['special-prices']);
                        }

                        console.error(errors)
                    });

                    invalidTabs = _.uniq(invalidTabs);

                    // check if the current tab
                    // is present in invalidTabs
                    // if not, go to next (first) invalid tab

                    const match = _.indexOf(invalidTabs, this.$route.fullPath);

                    // let switchTab = false;
                    if (match < 0) {
                        invalidTabs.every(invalidTab => {
                            if (invalidTab && this.activeTab !== invalidTab) {
                                const tab = _.find(this.tabs, { path: invalidTab });
                                if (tab) {
                                    this.activateTab(tab);

                                    // break loop after the first tab has been activated
                                    return false;
                                }
                            }
                        });
                    }

                    // // triger the validation again
                    // // so the previously hidden fields will get the errors
                    // // ---
                    // // does not work if the component has been destroyed
                    // // in the meantime (f.a. by switching tabs)
                    // if (switchTab === false) {
                    //     setTimeout(() => {
                    //         this.$refs.form.validate(() => {
                    //             // do nothing
                    //             // callback function is required :(
                    //         })
                    //     }, 100);
                    // }

                    this.$notify.warning({
                        title: this.$t('Form is not valid!'),
                        message: this.$t('Correct your input and submit again.'),
                        iconClass: 'fas el-icon-fa-exclamation-circle',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                }
            });
        },
        leave() {
            router.push(this.listRoute);
        },
        ...mapMutations({
            setInitializedFlag: 'ext_shop_property/form_initialized',
            setValidateOnEnterFlag: 'ext_shop_property/form_validateOnEnter',
            addTranslation: 'ext_shop_property/form/addTranslation',
            removeTranslation: 'ext_shop_property/form/removeTranslation',
            insertProperty: 'ext_shop_property/insertProperty',
        }),
        ...mapActions({
            activateTab: 'activateTab',
            fetchProperty: 'ext_shop_property/fetchProperty',
            fetchPropTypeOptions: 'ext_shop_property/fetchPropTypeOptions',
            fetchCustomerGroupOptions: 'ext_shop_property/fetchCustomerGroupOptions',
            fetchTaxOptions: 'ext_shop_property/fetchTaxOptions',
            translate: 'ext_shop_property/translate',
            save: 'ext_shop_property/save',
            delete: 'ext_shop_property/delete'
            // fetchPropertiesPaginated: 'ext_shop_property/fetchPropertiesPaginated',
        })
    },
    mounted() {
        this.initialize();
    },
    beforeRouteEnter(to, from, next) {
        // redirect if necessary
        const id = _.get(to, 'params.id') || 'new'

        if (to.name === 'property-form') {
            next({ name: 'property-main', params: { id } })
        } else {
            next()
        }
    },
    beforeRouteLeave(to, from, next) {
        next();

        // setTimeout(() => {
        // }, 300);

        store.dispatch('ext_shop_property/reset');
        store.commit('ext_shop_property/resetUI');
        this.$nextTick(() => store.commit('ext_shop_property/resetRules'));
    },
    destroyed() {
        // console.log('destroyed');
        // geht nicht .. leert das Formular bei klick auf anderen Reiter
        // store.dispatch('ext_shop_property/reset')
    }
};
</script>

<style lang="sass" scoped>
.el-card ::v-deep .el-card__body
    padding: 0
    & > section
        padding: 20px
.i18n-select-container
    margin: 20px
.properties-panel
    padding: 20px
    background: $color-body
    border-radius: 4px
    display: grid
    grid-auto-flow: row
    grid-template-columns: max-content auto
    gap: 1rem
    container-type: inline-size

    .property
        display: contents
    .el-form-item,
    .table-head
        display: grid
        grid-template-columns: subgrid
        grid-template-rows: subgrid
        grid-column: 1 / -1
        margin-bottom: 0
        &::v-deep
            .el-form-item__label
                grid-column: 1
                display: flex !important
                padding: 0 !important
                justify-content: flex-end
                align-items: center
            .el-form-item__content
                grid-column: 2
    .el-form-item.is-error
        margin-bottom: 10px
    .table-head
        opacity: .6
    .text-center
        text-align: center

.el-form-item
    &.hide-label::v-deep
        .el-form-item__label
            display: none !important
    &.no-margin
        margin: 0
</style>
